import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetCustomerAndPrepaidProductsQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetCustomerAndPrepaidProductsQuery = { __typename?: 'query_root', customers: Array<{ __typename?: 'customers', id: number, name?: string | null, billing_frequency: string, auto_pay: boolean }>, productfees: Array<{ __typename?: 'productfees', id: number, cost: number }> };


export const GetCustomerAndPrepaidProductsDocument = gql`
    query getCustomerAndPrepaidProducts($customerId: bigint!) {
  customers(where: {id: {_eq: $customerId}, active: {_eq: 1}}) {
    id
    name
    billing_frequency
    auto_pay
  }
  productfees(
    where: {raterulegroup: {customer_id: {_eq: $customerId}, begin_date: {_lte: "now()"}, _or: [{end_date: {_gte: "now()"}}, {end_date: {_is_null: true}}]}, product: {prepaid: {_eq: true}}}
  ) {
    id
    cost
  }
}
    `;

/**
 * __useGetCustomerAndPrepaidProductsQuery__
 *
 * To run a query within a React component, call `useGetCustomerAndPrepaidProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerAndPrepaidProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerAndPrepaidProductsQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetCustomerAndPrepaidProductsQuery(baseOptions: Apollo.QueryHookOptions<GetCustomerAndPrepaidProductsQuery, GetCustomerAndPrepaidProductsQueryVariables> & ({ variables: GetCustomerAndPrepaidProductsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerAndPrepaidProductsQuery, GetCustomerAndPrepaidProductsQueryVariables>(GetCustomerAndPrepaidProductsDocument, options);
      }
export function useGetCustomerAndPrepaidProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerAndPrepaidProductsQuery, GetCustomerAndPrepaidProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerAndPrepaidProductsQuery, GetCustomerAndPrepaidProductsQueryVariables>(GetCustomerAndPrepaidProductsDocument, options);
        }
// @ts-ignore
export function useGetCustomerAndPrepaidProductsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomerAndPrepaidProductsQuery, GetCustomerAndPrepaidProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerAndPrepaidProductsQuery, GetCustomerAndPrepaidProductsQueryVariables>;
export function useGetCustomerAndPrepaidProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerAndPrepaidProductsQuery, GetCustomerAndPrepaidProductsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomerAndPrepaidProductsQuery | undefined, GetCustomerAndPrepaidProductsQueryVariables>;
export function useGetCustomerAndPrepaidProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomerAndPrepaidProductsQuery, GetCustomerAndPrepaidProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomerAndPrepaidProductsQuery, GetCustomerAndPrepaidProductsQueryVariables>(GetCustomerAndPrepaidProductsDocument, options);
        }
export type GetCustomerAndPrepaidProductsQueryHookResult = ReturnType<typeof useGetCustomerAndPrepaidProductsQuery>;
export type GetCustomerAndPrepaidProductsLazyQueryHookResult = ReturnType<typeof useGetCustomerAndPrepaidProductsLazyQuery>;
export type GetCustomerAndPrepaidProductsSuspenseQueryHookResult = ReturnType<typeof useGetCustomerAndPrepaidProductsSuspenseQuery>;
export type GetCustomerAndPrepaidProductsQueryResult = Apollo.QueryResult<GetCustomerAndPrepaidProductsQuery, GetCustomerAndPrepaidProductsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (customers, productfees): returns the full response object.
 * @source {@link src/features/billing/queries/getCustomerAndPrepaidProducts.query.gql}
 */
export async function getCustomerAndPrepaidProducts(
  variables: GetCustomerAndPrepaidProductsQueryVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<GetCustomerAndPrepaidProductsQuery> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).query<GetCustomerAndPrepaidProductsQuery>(
    GetCustomerAndPrepaidProductsDocument,
    variables,
    requestOptions
  )
}